import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { recordingsApi, RecordingResponse } from '@/api/telemedicine-api';

export function useRecording(sessionId: string) {
  const [isRecording, setIsRecording] = useState(false);
  const [currentRecording, setCurrentRecording] = useState<RecordingResponse | null>(null);

  const startRecording = useMutation({
    mutationFn: () => recordingsApi.startRecording(sessionId),
    onSuccess: (response) => {
      setIsRecording(true);
      setCurrentRecording(response.data);
    },
  });

  const stopRecording = useMutation({
    mutationFn: () => recordingsApi.stopRecording(sessionId),
    onSuccess: (response) => {
      setIsRecording(false);
      setCurrentRecording(response.data);
    },
  });

  const deleteRecording = useMutation({
    mutationFn: (recordingId: string) => recordingsApi.deleteRecording(recordingId),
    onSuccess: () => {
      setCurrentRecording(null);
    },
  });

  return {
    isRecording,
    currentRecording,
    startRecording: startRecording.mutateAsync,
    stopRecording: stopRecording.mutateAsync,
    deleteRecording: deleteRecording.mutateAsync,
    isStarting: startRecording.isPending,
    isStopping: stopRecording.isPending,
  };
}
